import { useDeviceType } from '@cian/ui-kit';
import { Socials } from '../Socials';
import * as styles from './styles.css';
import { clsx } from 'clsx';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['logo']} />
      <Socials theme="black" />
    </div>
  );
};
